import { StaffAsyncSelect } from '@/pages/POS/components/StaffAsyncSelect';

interface Props {
  value?: string;
  onChange: (staffId: string) => void;
  storeId?: string;
  placeholder?: string;
  status?: 'error' | 'warning';
}

export function CareStaffAsyncSelect({ value, onChange, storeId, placeholder = 'Chọn nhân viên chăm sóc', status }: Props) {
  return (
    <StaffAsyncSelect
      value={value}
      onChange={onChange}
      storeId={storeId}
      placeholder={placeholder}
      warning={status === 'warning'}
    />
  );
}
